// extracted by mini-css-extract-plugin
export default {"value":"PileParametersSection_value__xTA4b","wrapper":"PileParametersSection_wrapper__-UHeo"};